// ============================================================
// CONFIGURATION - FILL IN YOUR EMAILJS CREDENTIALS
// Sign up free at emailjs.com then:
// 1. Add an Email Service (Gmail or your SMTP)
// 2. Create a template - use variables: to_name, to_email,
//    biz_name, inv_number, inv_date, plan_label, plan_price,
//    hosting_line, subtotal, vat_amount, total, invoice_html
// 3. Paste your IDs below
// ============================================================
var WS_CFG = {
  publicKey:  'R2nmUbCGuEzBfBvD4',
  serviceId:  'service_fjhizpi',
  templateId: 'template_jlf35rg'
};

// PLAN + HOSTING DATA
var wsPlans = {
  starter: { label: 'Website Build - Starter (Up to 6 pages)', price: 899,  revisions: 3, pages: 6  },
  growth:  { label: 'Website Build - Growth (Up to 8 pages)',   price: 999,  revisions: 5, pages: 8  },
  premium: { label: 'Website Build - Premium (Up to 10 pages)', price: 1099, revisions: 7, pages: 10 }
};
var wsHosting = {
  none:    { label: null,                                              price: 0       },
  monthly: { label: 'Managed WordPress Hosting - Monthly',            price: 49.95   },
  annual:  { label: 'Managed WordPress Hosting - Annual (20% off)',   price: 479.52  }
};
var wsDomain = {
  own:   { label: null, price: 0, note: null },
  have:  { label: null, price: 0, note: null },
  com:   { label: '.com Domain Registration (1 year)',     price: 50,  note: 'Registered and managed by Websoft. We will provide login details.' },
  comfj: { label: '.com.fj Domain Registration (1 year)',  price: 100, note: 'Registered directly with USP by client. We will provide DNS records. Payment made separately to USP - not included in this invoice.' }
};

// INIT EMAILJS
if (typeof emailjs !== 'undefined') {
  emailjs.init({ publicKey: WS_CFG.publicKey });
}

// SLOTS
(function() {
  var taken = 7, total = 20;
  var ce = document.getElementById('wsSlotCount');
  var se = document.getElementById('wsSlots');
  if (ce) ce.textContent = total - taken;
  if (se) {
    for (var i = 0; i < total; i++) {
      var d = document.createElement('span');
      d.className = 'ws-slot ' + (i < taken ? 'taken' : 'available');
      se.appendChild(d);
    }
  }
})();

function selectPlan(val) {
  var s = document.getElementById('wf-plan');
  if (s) s.value = val;
  document.getElementById('wsFormAnchor').scrollIntoView({ behavior: 'smooth' });
}

function wsFaq(btn) {
  var a = btn.nextElementSibling;
  var isOpen = a.classList.contains('open');
  document.querySelectorAll('.ws-faq-a.open').forEach(function(el) { el.classList.remove('open'); });
  document.querySelectorAll('.ws-faq-q.open').forEach(function(el) { el.classList.remove('open'); });
  if (!isOpen) { a.classList.add('open'); btn.classList.add('open'); }
}

function wsZeroPad(n) {
  return n < 10 ? '0' + n : '' + n;
}
function wsFmt(n) {
  var parts = n.toFixed(2).split('.');
  var intPart = parts[0];
  var result = '';
  var count = 0;
  for (var i = intPart.length - 1; i >= 0; i--) {
    if (count > 0 && count % 3 === 0) result = ',' + result;
    result = intPart[i] + result;
    count++;
  }
  return '$' + result + '.' + parts[1] + ' FJD';
}

function wsValidEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e); }

function wsClearErr(id) {
  var el = document.getElementById(id);
  if (el) el.classList.remove('ws-err');
  var err = document.getElementById('err-' + id.replace('wf-', ''));
  if (err) err.classList.remove('show');
}

function wsShowErr(id, msg) {
  var el = document.getElementById(id);
  if (el) el.classList.add('ws-err');
  var err = document.getElementById('err-' + id.replace('wf-', ''));
  if (err) { if (msg) err.textContent = msg; err.classList.add('show'); }
}

function buildInvoiceHtml(d) {
  var p    = wsPlans[d.plan];
  var h    = wsHosting[d.hosting];
  var dom  = wsDomain[d.domain] || wsDomain['own'];
  var dp   = d.domPrice || 0;
  var sub  = p.price + h.price + dp;
  var vatBase = p.price + h.price;
  var vat  = vatBase * 0.125;
  var total = sub + vat;
  var rows = '<tr><td style="padding:8px 0;border-bottom:1px solid #eee;font-size:13px">' + p.label + '<br><small style="color:#888">' + p.pages + ' pages, ' + p.rev + ' revisions, 3-day delivery</small></td><td style="padding:8px 6px;border-bottom:1px solid #eee;text-align:center;font-size:13px">1</td><td style="padding:8px 0;border-bottom:1px solid #eee;text-align:right;font-size:13px">' + wsFmt(p.price) + '</td><td style="padding:8px 0;border-bottom:1px solid #eee;text-align:right;font-weight:bold;font-size:13px">' + wsFmt(p.price) + '</td></tr>';
  if (h.price > 0) {
    rows += '<tr><td style="padding:8px 0;font-size:13px;border-bottom:1px solid #eee">' + h.label + '<br><small style="color:#888">Modern managed WordPress hosting</small></td><td style="padding:8px 6px;text-align:center;font-size:13px;border-bottom:1px solid #eee">1</td><td style="padding:8px 0;text-align:right;font-size:13px;border-bottom:1px solid #eee">' + wsFmt(h.price) + '</td><td style="padding:8px 0;text-align:right;font-weight:bold;font-size:13px;border-bottom:1px solid #eee">' + wsFmt(h.price) + '</td></tr>';
  }
  if (dp > 0) {
    var dn = d.domain === 'comfj' ? 'Paid separately to USP. Websoft provides DNS records. Not subject to VAT.' : 'Registered and managed by Websoft. Not subject to VAT.';
    rows += '<tr><td style="padding:8px 0;font-size:13px">' + dom.label + '<br><small style="color:#888">' + dn + '</small></td><td style="padding:8px 6px;text-align:center;font-size:13px">1</td><td style="padding:8px 0;text-align:right;font-size:13px">' + wsFmt(dp) + ' VEP</td><td style="padding:8px 0;text-align:right;font-weight:bold;font-size:13px">' + wsFmt(dp) + '</td></tr>';
  }
  return '<div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;color:#111">' +
    '<div style="background:#0d0d0d;padding:22px 26px;border-radius:8px 8px 0 0"><img src="https://www.websoft.com.fj/cdn/shop/files/Websoft_Main_Logo_-_White.png?v=1731833648&width=150" alt="Websoft" style="height:36px;width:auto;display:block;margin-bottom:6px"><p style="color:#888;margin:0;font-size:12px">VAT Reg: 50-57333-0-8 | info@websoft.com.fj | websoft.com.fj</p></div>' +
    '<div style="border:1px solid #e0dbd4;border-top:none;border-radius:0 0 8px 8px;padding:26px">' +
    '<table style="width:100%;margin-bottom:16px;border-collapse:collapse"><tr><td style="vertical-align:top;padding-bottom:12px"><strong style="font-size:15px">PROFORMA INVOICE</strong><br><span style="color:#888;font-size:12px">No: ' + d.invNum + '</span><br><span style="color:#888;font-size:12px">Date: ' + d.invDate + '</span></td><td style="text-align:right;vertical-align:top;padding-bottom:12px;font-size:13px"><strong>Bill To:</strong><br>' + d.biz + '<br>' + d.name + '<br>' + d.email + '</td></tr></table>' +
    '<table style="width:100%;border-collapse:collapse;margin-bottom:4px"><thead><tr style="border-bottom:2px solid #0d0d0d"><th style="padding:6px 0;text-align:left;font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#888;font-weight:600">Description</th><th style="padding:6px 4px;text-align:center;font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#888;font-weight:600">Qty</th><th style="padding:6px 0;text-align:right;font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#888;font-weight:600">Unit Price</th><th style="padding:6px 0;text-align:right;font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#888;font-weight:600">Amount</th></tr></thead><tbody>' + rows + '</tbody></table>' +
    '<div style="border-top:2px solid #0d0d0d;padding-top:12px">' +
    '<div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:5px;color:#666"><span>Subtotal (excl. VAT)</span><span>' + wsFmt(sub) + '</span></div>' +
    '<div style="display:flex;justify-content:space-between;font-size:13px;margin-bottom:5px;color:#666"><span>VAT @ 12.5%</span><span>' + wsFmt(vat) + '</span></div>' +
    '<div style="display:flex;justify-content:space-between;font-size:17px;font-weight:800;margin-top:8px;padding-top:10px;border-top:1px solid #e0dbd4"><span>TOTAL (incl. VAT)</span><span style="color:#c8410a">' + wsFmt(total) + '</span></div></div>' +
    '<div style="background:#f7f5f2;border-radius:6px;padding:14px;margin-top:18px;font-size:12.5px;color:#666"><strong style="color:#111">Payment via Bank Deposit</strong><br>Westpac Banking Corporation | Account Name: Websoft Pte Ltd | Account No: 9807630836 | BSB: 039001 | SWIFT: WPACFJFX<br><strong style="color:#c8410a">Reference: ' + d.biz + '</strong></div>' +
    '<div style="background:#fffbf0;border:1px solid #f0e0b0;border-radius:6px;padding:10px 14px;margin-top:10px;font-size:11.5px;color:#7a6020">All prices are VAT Exclusive (VEP) as per FRCS regulations. VAT 12.5% applies to website build and hosting only. Domain registration fees are VEP and not subject to VAT. This is a proforma invoice - final tax invoice issued upon payment confirmation.</div>' +
    '<p style="font-size:12px;color:#aaa;margin-top:14px">After depositing, email your receipt to info@websoft.com.fj with your business name as the reference.</p>' +
    '</div></div>';
}

function wsSubmit() {
  var name     = document.getElementById('wf-name').value.trim();
  var biz      = document.getElementById('wf-biz').value.trim();
  var email    = document.getElementById('wf-email').value.trim();
  var phone    = document.getElementById('wf-phone').value.trim();
  var niche    = document.getElementById('wf-niche').value.trim();
  var plan     = document.getElementById('wf-plan').value;
  var pages    = document.getElementById('wf-pages').value.trim();
  var terms    = document.getElementById('wf-terms').checked;
  var hostVal  = document.getElementById('wf-hosting').value;
  var domVal   = document.getElementById('wf-domain').value;
  var refCode  = document.getElementById('wf-refcode').value.trim().toUpperCase();
  var color1   = document.getElementById('wf-color1').value.trim();
  var color2   = document.getElementById('wf-color2').value.trim();
  var services = document.getElementById('wf-services').value.trim();
  var fb       = document.getElementById('wf-fb').value.trim();
  var ig       = document.getElementById('wf-ig').value.trim();
  var ref      = document.getElementById('wf-ref').value.trim();
  var logo     = document.getElementById('wf-logo').value;
  var notes    = document.getElementById('wf-notes').value.trim();

  var hasErrors = false;

  ['wf-name','wf-biz','wf-email','wf-phone','wf-niche','wf-plan','wf-pages'].forEach(wsClearErr);
  document.getElementById('wsTermsWrap').classList.remove('ws-err');
  document.getElementById('err-terms').style.display = 'none';
  document.getElementById('wsGlobalError').classList.remove('show');

  if (!name)                         { wsShowErr('wf-name',  'Please enter your full name.');         hasErrors = true; }
  if (!biz)                          { wsShowErr('wf-biz',   'Please enter your business name.');     hasErrors = true; }
  if (!email || !wsValidEmail(email)){ wsShowErr('wf-email', 'Please enter a valid email address.');  hasErrors = true; }
  if (!phone)                        { wsShowErr('wf-phone', 'Please enter your phone number.');      hasErrors = true; }
  if (!niche)                        { wsShowErr('wf-niche', 'Please enter your business industry.'); hasErrors = true; }
  if (!plan)                         { wsShowErr('wf-plan',  'Please select a package.');             hasErrors = true; }
  if (!pages)                        { wsShowErr('wf-pages', 'Please list the pages you need.');      hasErrors = true; }
  if (!terms) {
    document.getElementById('wsTermsWrap').classList.add('ws-err');
    document.getElementById('err-terms').style.display = 'block';
    hasErrors = true;
  }

  if (hasErrors) {
    var box = document.getElementById('wsGlobalError');
    document.getElementById('wsGlobalErrorMsg').textContent = 'Please fill in all required fields and agree to the terms.';
    box.classList.add('show');
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }

  var btn = document.getElementById('wsSubmitBtn');
  btn.disabled = true;
  btn.textContent = 'Submitting...';
  document.getElementById('wsSendingOverlay').classList.add('show');

  var p = wsPlans[plan];
  var h = wsHosting[hostVal];
  var d = wsDomain[domVal] || wsDomain['own'];
  var buildVat   = p.price * 0.125;
  var domPrice   = d.price || 0;
  var vatBase    = p.price + h.price;
  var sub        = vatBase + domPrice;
  var totalVat   = vatBase * 0.125;
  var grandTotal = sub + totalVat;
  var hostVatAmt = h.price * 0.125;
  var hostTotal  = h.price + hostVatAmt;

  var now     = new Date();
  var invNum  = 'WS-' + now.getFullYear() + wsZeroPad(now.getMonth()+1) + wsZeroPad(now.getDate()) + '-' + String(Math.floor(Math.random()*9000)+1000);
  var invDate = now.toLocaleDateString('en-FJ', { day: 'numeric', month: 'long', year: 'numeric' });

  // STEP 1 - Shopify contact form POST
  var fd = new FormData();
  fd.append('form_type', 'contact');
  fd.append('utf8', '\u2713');
  fd.append('contact[name]',  name);
  fd.append('contact[email]', email);
  fd.append('contact[phone]', phone);
  fd.append('contact[body]',
    'NEW WEBSITE APPLICATION\n\n' +
    'Business: ' + biz + '\n' +
    'Industry: ' + niche + '\n' +
    'Phone: ' + phone + '\n' +
    'Package: ' + p.label + ' - ' + wsFmt(p.price) + ' excl. VAT\n' +
    'Hosting: ' + (h.price > 0 ? h.label + ' - ' + wsFmt(h.price) + ' excl. VAT' : 'None') + '\n' +
    'Invoice No: ' + invNum + '\n' +
    'Total incl. VAT: ' + wsFmt(grandTotal) + '\n\n' +
    'Pages: ' + pages + '\n' +
    'Primary Colour: ' + (color1 || 'Not specified') + '\n' +
    'Secondary Colour: ' + (color2 || 'Not specified') + '\n' +
    'Services: ' + (services || 'Not provided') + '\n' +
    'Facebook: ' + (fb || 'Not provided') + '\n' +
    'Instagram: ' + (ig || 'Not provided') + '\n' +
    'Logo: ' + logo + '\n' +
    'References: ' + (ref || 'None') + '\n' +
    'Notes: ' + (notes || 'None') + '\n' +
    'Domain: ' + domVal + (domPrice > 0 ? ' - ' + wsFmt(domPrice) + ' VEP' : '') + '\n' +
    'Referral Code: ' + (refCode || 'None') + '\n' +
    'Terms agreed: Yes'
  );

  fetch('/contact', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
    .catch(function() {});

  // STEP 2 - EmailJS
  var emailStatusEl = document.getElementById('wsEmailStatus');
  emailStatusEl.className = 'ws-email-status sending';
  emailStatusEl.textContent = '📧 Sending your invoice by email...';
  emailStatusEl.style.display = 'block';

  var invoiceData = { name: name, biz: biz, email: email, plan: plan, hosting: hostVal, domain: domVal, domPrice: domPrice, d: d, invNum: invNum, invDate: invDate };

  var sendEmail = function() {
    if (typeof emailjs === 'undefined' || WS_CFG.publicKey === 'YOUR_PUBLIC_KEY') {
      emailStatusEl.className = 'ws-email-status sent';
      emailStatusEl.textContent = '✅ Application received. We will email your invoice to ' + email + ' shortly.';
      return Promise.resolve();
    }
    return emailjs.send(WS_CFG.serviceId, WS_CFG.templateId, {
      to_name:      name,
      to_email:     email,
      biz_name:     biz,
      inv_number:   invNum,
      inv_date:     invDate,
      plan_label:   p.label,
      plan_price:   wsFmt(p.price),
      hosting_line: h.price > 0 ? h.label + ' - ' + wsFmt(h.price) + ' excl. VAT' : 'No hosting selected',
      domain_line:  d.price > 0 ? d.label + ' - ' + wsFmt(d.price) + ' VEP (not VAT-able)' : (domVal === 'have' ? 'Client already has domain' : 'Client will register own domain'),
      ref_code:     refCode || 'None',
      subtotal:     wsFmt(sub),
      vat_amount:   wsFmt(totalVat),
      total:        wsFmt(grandTotal),
      invoice_html: buildInvoiceHtml(invoiceData),
      reply_to:     'info@websoft.com.fj'
    });
  };

  sendEmail()
    .then(function() {
      if (WS_CFG.publicKey !== 'YOUR_PUBLIC_KEY') {
        emailStatusEl.className = 'ws-email-status sent';
        emailStatusEl.textContent = '✅ Invoice sent to ' + email + ' - check your inbox (and spam folder just in case).';
      }
    })
    .catch(function(err) {
      emailStatusEl.className = 'ws-email-status failed';
      emailStatusEl.textContent = '⚠️ Could not send email automatically. Please use the Print button to save your invoice. We will also be in touch at ' + email + ' shortly.';
      console.warn('EmailJS error:', err);
    });

  // STEP 3 - Render invoice on page
  document.getElementById('wsConfirmName').textContent  = name;
  document.getElementById('wsConfirmEmail').textContent = email;
  document.getElementById('wsBizRef').textContent       = biz;
  document.getElementById('wsAmountExVat').textContent  = wsFmt(p.price);
  document.getElementById('wsAmountVat').textContent    = wsFmt(buildVat);
  document.getElementById('wsAmountTotal').textContent  = wsFmt(grandTotal);

  if (h.price > 0) {
    var hr = document.getElementById('wsHostingRow');
    hr.style.display = 'flex';
    document.getElementById('wsHostingLabel').textContent  = h.label + ' (incl. VAT)';
    document.getElementById('wsHostingAmount').textContent = wsFmt(hostTotal);
  }
  if (domPrice > 0) {
    var dr = document.getElementById('wsDomainRow');
    dr.style.display = 'flex';
    document.getElementById('wsDomainLabel').textContent  = d.label + ' (VEP - VAT not applied)';
    document.getElementById('wsDomainAmount').textContent = wsFmt(domPrice);
  }
  if (domVal === 'comfj') {
    var fn = document.getElementById('wsDomainNote');
    fn.style.display = 'block';
    fn.textContent = 'Note: .com.fj domains are registered directly with USP by the client. Websoft will provide DNS records. The $100 FJD fee is paid separately to USP and is not included in this invoice.';
  }

  if (domVal === 'comfj') {
    var din = document.getElementById('wsDomainInvNote');
    if (din) {
      din.style.display = 'block';
      din.textContent = 'Note: .com.fj domain ($100 FJD VEP) is registered directly with USP by the client. Websoft will provide all required DNS records. This fee is paid separately to USP and is not subject to VAT.';
    }
  }

  document.getElementById('wsInvNum').textContent    = invNum;
  document.getElementById('wsInvDate').textContent   = invDate;
  document.getElementById('wsInvClient').textContent = biz + ' (' + name + ')';
  document.getElementById('wsInvRef').textContent    = biz;

  var rows = '<tr><td style="padding:10px 0;border-bottom:1px solid var(--rule)">' + p.label + '<br><small style="color:var(--mid)">' + p.pages + ' pages, ' + p.revisions + ' revision rounds, 3-day delivery</small></td><td style="padding:10px 4px;border-bottom:1px solid var(--rule)">1</td><td style="padding:10px 0;border-bottom:1px solid var(--rule)">' + wsFmt(p.price) + '</td><td style="padding:10px 0;border-bottom:1px solid var(--rule)">' + wsFmt(p.price) + '</td></tr>';
  if (h.price > 0) {
    rows += '<tr><td style="padding:10px 0;border-bottom:1px solid var(--rule)">' + h.label + '<br><small style="color:var(--mid)">Modern managed WordPress hosting</small></td><td style="padding:10px 4px;border-bottom:1px solid var(--rule)">1</td><td style="padding:10px 0;border-bottom:1px solid var(--rule)">' + wsFmt(h.price) + '</td><td style="padding:10px 0;border-bottom:1px solid var(--rule)">' + wsFmt(h.price) + '</td></tr>';
  }
  if (domPrice > 0) {
    var domNote = domVal === 'comfj' ? 'Paid separately to USP. Websoft provides DNS records.' : 'Registered and managed by Websoft.';
    rows += '<tr><td style="padding:10px 0">' + d.label + '<br><small style="color:var(--mid)">' + domNote + '</small></td><td style="padding:10px 4px">1</td><td style="padding:10px 0">' + wsFmt(domPrice) + '</td><td style="padding:10px 0">' + wsFmt(domPrice) + '</td></tr>';
  }

  document.getElementById('wsInvRows').innerHTML       = rows;
  document.getElementById('wsInvSubtotal').textContent = wsFmt(sub);
  document.getElementById('wsInvVat').textContent      = wsFmt(totalVat);
  document.getElementById('wsInvTotal').textContent    = wsFmt(grandTotal);

  document.getElementById('wsFormGrid').style.display = 'none';
  var s = document.getElementById('wsSuccess');
  s.style.display = 'block';
  s.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

// SCROLL ANIMATIONS
var wsObs = new IntersectionObserver(function(entries) {
  entries.forEach(function(e, i) {
    if (e.isIntersecting) setTimeout(function() { e.target.classList.add('visible'); }, i * 70);
  });
}, { threshold: 0.07 });
document.querySelectorAll('.ws-why-item,.ws-inc-item,.ws-step,.ws-plan,.ws-term').forEach(function(el) { wsObs.observe(el); });

// LIVE ERROR CLEARING
['wf-name','wf-biz','wf-email','wf-phone','wf-niche','wf-plan','wf-pages'].forEach(function(id) {
  var el = document.getElementById(id);
  if (el) {
    el.addEventListener('input',  function() { wsClearErr(id); });
    el.addEventListener('change', function() { wsClearErr(id); });
  }
});
document.getElementById('wf-terms').addEventListener('change', function() {
  if (this.checked) {
    document.getElementById('wsTermsWrap').classList.remove('ws-err');
    document.getElementById('err-terms').style.display = 'none';
  }
});